const blogServiceMixin = {
    data: function () {
        return {
            BLOG_BASE: '/Api/Blog/'
        }
    },
    methods: {
        getBlogPosts: function(purchaseOrderData) { 
            return this.post(this.BLOG_BASE, 'GetPosts', purchaseOrderData);
        },
        getHomePageBlogPosts: function(purchaseOrderData) {
            return this.get(this.BLOG_BASE, 'GetHomePageBlogPosts', purchaseOrderData);
        }
    }
}